// extracted by mini-css-extract-plugin
export default {"root":"CardWrapper_root__ukWm2"};